import styles from './FileInput.module.css';
import cn from 'classnames';
import { forwardRef, useState } from 'react';
import { ForwardedRef } from 'react';
import { FileInputProps } from './FileInput.props';

export const FileInput = forwardRef(
  (
    {
      textLabel,
      id,
      error,
      style,
      className,
      accept,
      multiple = false,
      ...props
    }: FileInputProps,
    ref: ForwardedRef<HTMLInputElement>,
  ): JSX.Element => {
    const [fileName, setFileName] = useState<string>('');

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (file) {
        setFileName(file.name);
      } else {
        setFileName('');
      }

      props.onChange?.(e); // проброс наверх
    };

    const showFloating = fileName.length > 0;

    return (
      <div
        className={cn(styles.textField, styles.textFieldFloating, className)}
        style={style}
      >
        <div className={styles.fileInputContent}>
          <span className={styles.fileName}>
            {fileName || 'Файл не выбран'}
          </span>
          <label htmlFor={id} className={styles.uploadButton}>
            Добавить
          </label>
        </div>

        <label
          className={cn(styles.textFieldLabel, {
            [styles.floating]: showFloating,
          })}
          htmlFor={id}
        >
          {textLabel}
        </label>

        <input
          type="file"
          id={id}
          accept={accept}
          multiple={multiple}
          className={styles.hiddenInput}
          onChange={handleChange}
          ref={ref}
        />

        {error && (
          <span className={styles.error}>{error?.message as string}</span>
        )}
      </div>
    );
  },
);
